import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IndexComponent } from './pages/index/index.component';
import { ManualsComponent } from './pages/manuals/manuals.component';
import { MaterialsComponent } from './pages/materials/materials.component';

const routes: Routes = [
  { path: '', component: IndexComponent, pathMatch: 'full' },
  { path: 'materials', redirectTo: 'materials/educational', pathMatch: 'full' },
  { path: 'materials/diagnostic', component: MaterialsComponent, pathMatch: 'full' },
  { path: 'materials/educational', component: MaterialsComponent, pathMatch: 'full' },
  { path: 'manuals', component: ManualsComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
